import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../actions/users';
import EthnicityInput from './EthnicityInput';
import GenderInput from './GenderInput';

const UpdateProfileForm = ({ handleDelete, handleSubmit, setShowDeleteModal }) => {
    const dispatch = useDispatch();
    const userProfile = useSelector((state) => state.users.user);

    const [localFormData, setLocalFormData] = useState({
        username: '',
        email: '',
        password: '',
        roleType: '',
        gender: '',
        dateOfBirth: '',
        ethnicity: '',
        community: '',
    });

    // Get the user ID from localStorage
    const getUserId = () => {
        try {
            const storedProfile = localStorage.getItem('profile');
            if (!storedProfile) {
                console.warn('No profile found in localStorage.');
                return null;
            }

            const parsedProfile = JSON.parse(storedProfile);
            //console.log('Parsed Profile:', parsedProfile);
            if (!parsedProfile?.id) {
                console.warn('Invalid profile structure in localStorage:', parsedProfile);
                return null;
            }

            return parsedProfile.id; // Use `id` instead of `result._id`
        } catch (error) {
            console.error('Error retrieving user ID from localStorage:', error);
            return null;
        }
    };

    // Fetch user data when the component mounts
    useEffect(() => {
        const userId = getUserId();
        if (userId) {
            dispatch(getUser(userId)); // Dispatch the getUser action to fetch the user's profile
        } else {
            console.warn('User ID not found. Cannot fetch user profile.');
        }
    }, [dispatch]);

    // Update localFormData when userProfile is fetched
    useEffect(() => {
        if (userProfile) {
            //console.log('Fetching User Profile:', userProfile);
            setLocalFormData({
                username: userProfile.username || '',
                email: userProfile.email || '',
                password: userProfile.password,
                roleType: userProfile.roleType,
                gender: userProfile.gender || '',
                dateOfBirth: userProfile.dateOfBirth ? userProfile.dateOfBirth.split('T')[0] : '',
                ethnicity: userProfile.ethnicity || '',
                community: userProfile.community || '',
            });
            //console.log('Updated localFormData:', localFormData); // Debugging
        }
    }, [userProfile]);

    useEffect(() => {
        //console.log('Updated localFormData:', localFormData);
    }, [localFormData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        handleSubmit(localFormData); // Pass the form data to the parent component
    };

    return (
        <form onSubmit={handleFormSubmit}>
            <div className="form-group">
                <label htmlFor="username-input"><strong>Username</strong></label>
                <input
                    id="username-input"
                    name="username"
                    type="text"
                    value={localFormData.username}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete='false'
                    autoFocus
                />
            </div>
            <div className="form-group">
                <label htmlFor="email-input"><strong>Email</strong></label>
                <input
                    id="email-input"
                    name="email"
                    type="text"
                    value={localFormData.email}
                    onChange={handleChange}
                    className="form-control"
                    autoComplete='false'
                />
            </div>
            <div className="form-group">
                <GenderInput value={localFormData.gender} onChange={handleChange} />
            </div>
            <div className="form-group">
                <label htmlFor="dob-input"><strong>Date of Birth</strong></label>
                <input
                    id="dob-input"
                    name="dateOfBirth"
                    type="date"
                    value={localFormData.dateOfBirth}
                    onChange={handleChange}
                    max={new Date().toISOString().split("T")[0]}
                    className="form-control"
                />
            </div>
            <div className="form-group">
                <EthnicityInput value={localFormData.ethnicity} onChange={handleChange} />
            </div>
            <div className="form-group">
                <label htmlFor="community-input"><strong>Part of GGC Community</strong></label>
                <select
                    id="community-input"
                    name="community"
                    value={localFormData.community}
                    onChange={handleChange}
                    className="form-control">
                    <option value={localFormData.community}>{localFormData.community}</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                </select>
            </div>
            <div className="form-group d-flex justify-content-center gap-3 mt-4">
                <button 
                    type="button" 
                    className="btn btn-danger" 
                    onClick={() => setShowDeleteModal(true)} >
                    Delete Profile
                </button>
                <button
                    type="submit"
                    className="btn btn-blue"
                >
                    Submit Changes
                </button>
            </div>
        </form>
    );
};

export default UpdateProfileForm;